import type { PreviewError } from '@hooks/useDocumentPreview';

/**
 * A missing source file is a 404 (documents.py / simple_upload.py preview routes),
 * so the status decides between "the file is gone, re-upload it" and "the request
 * failed, retry it". A null status means no response arrived at all, which is a
 * network failure — retryable, never a missing file.
 */
export const isFileNotFoundError = (error: PreviewError): boolean => error.status === 404;
